import {
	ArrowButtons,
	Breakpoints,
	ContainerGutter,
	Gallery,
	GallerySlide,
	Lentils,
} from '@volkswagen-onehub/components-core';
import React from 'react';
import styled from 'styled-components';
import { LentilsWrapper } from '../../ui/lentils-wrapper';
import { NovedadesCard } from './novedades-card';
import { NovedadesItem } from '../novedades-type';

interface NovedadesCarouselProps {
	novedades: NovedadesItem[];
}

// añadir padding a las gallery slides para la shadow de la card
const GallerySlideContainer = styled(GallerySlide)`
	padding: 10px;
`;

export const NovedadesCarousel = ({ novedades }: NovedadesCarouselProps) => {
	return (
		<Gallery
			data-testid="novedades-gallery-slider"
			id="novedades-gallery"
			bottomElements={
				<>
					<ArrowButtons buttonPreviousAriaLabel="To previous slide" buttonNextAriaLabel="To next slide" />

					{/* si todas las slides caben en pantalla - no mostrar lentils */}
					<LentilsWrapper $count={novedades.length}>
						<Lentils />
					</LentilsWrapper>
				</>
			}
			aria-label="novedades gallery"
			slidesPerPage={{
				[Breakpoints.default]: 1,
				[Breakpoints.b960]: novedades.length >= 2 ? 2 : novedades.length,
				[Breakpoints.b1600]: novedades.length >= 3 ? 3 : novedades.length,
				[Breakpoints.b2560]: novedades.length >= 4 ? 4 : novedades.length,
			}}
			fadingEdges="normal"
			gutter={ContainerGutter.dynamic0100}
		>
			{[
				...novedades.map((novedadesItem, index) => (
					<GallerySlideContainer key={index} aria-labelledby={`slide${index}-heading`} stretch>
						<NovedadesCard novedades={novedadesItem} />
					</GallerySlideContainer>
				)),
			]}
		</Gallery>
	);
};
